// PDP页面根据面包屑获取产品的category、subcategory信息
export const usePdpCategory = ({category, subCategory} = {}) => {
    // plp、search、related product、wish list后端会提供category、subcategory数据，所以直接返回
    if(category || subCategory){
        return{
            category: category || subCategory,
            subCategory,
        }
    }

    const $breadcumb = document.querySelector(".breadcrumb");
    if(!$breadcumb){
        return {};
    }

    const itemLen = $breadcumb.querySelectorAll("li")?.length ?? 0;
    // 如果面包屑的层级小于3，则说明pdp没有category，此时返回空
    if(itemLen < 3){
        return {};
    }

    const breadSubcategory = $breadcumb.querySelector("li:nth-last-child(2) a")?.innerHTML??"";
    let bradCategory = "";
    // 如果面包屑只有3级，则说明只有category一层，没有subcategory
    if(itemLen === 3){
        bradCategory = breadSubcategory;
    }else{
        bradCategory = $breadcumb.querySelector("li:nth-last-child(3) a")?.innerHTML??"";
    }

    return {
        category:bradCategory,
        subCategory:breadSubcategory,
    }
}